export const VisitorChartData = {
  	series: [
		{
			name: "Page Views",
			data: [35, 41, 62, 42, 13, 18, 29, 37, 36, 51, 32, 35]
		}
	],
	categories:[
		'01 Jan', 
		'02 Jan', 
		'03 Jan', 
		'04 Jan', 
		'05 Jan', 
		'06 Jan', 
		'07 Jan', 
		'08 Jan', 
		'09 Jan',
		'10 Jan', 
		'11 Jan', 
		'12 Jan'
	]
}

export const AnnualStatisticData = [
	{
		title: 'Total Visitors',
		value:'134', 
		status: -11.4,
		subtitle: `Compare to last month (2020)`
	},
	{
		title: 'Events',
		value:'54', 
		status: 8.2,
		subtitle: `Compare to last month (2020)`
	},
	{
		title: 'Stories',
		value:'43', 
		status: 0.7,
		subtitle: `Compare to last month (2020)`
	},
	{
		title: 'Recources',
		value:'45', 
		status: 1.23,
		subtitle: `Compare to last month (2020)`
	}
]

export const ActiveMembersData = [{
	name: 'Members',
	data: [25, 15, 41, 25, 44, 12, 36, 19, 54]
}]

export const NewMembersData = [{
	img: "/img/avatars/thumb-2.jpg",
	title: "Software Engineer",
	name: "Terrance Moreno",
},
{
	img: "/img/avatars/thumb-3.jpg",
	title: "UI/UX Designer",
	name: "Ron Vargas",
},
{
	img: "/img/avatars/thumb-4.jpg",
	title: "HR Executive",
	name: "Luke Cook",
},
{
	img: "/img/avatars/thumb-5.jpg",
	title: "Frontend Developer",
	name: "Joyce Freeman",
},
{
	img: "/img/avatars/thumb-6.jpg",
	title: "Compliance Manager",
	name: "Samantha Phillips",
}]

export const RecentTransactionData = [
	{
		id: '#5331',
		name: 'Clayton Bates',
		date: '8 May 2020',
		amount: '$137.00',
		status: 'Approved',
		avatarColor: '#04d182'
	},
	{
		id: '#5332',
		name: 'Gabriel Frazier',
		date: '6 May 2020',
		amount: '$322.00',
		status: 'Approved',
		avatarColor: '#fa8c16'
	},
	{
		id: '#5333',
		name: 'Debra Hamilton',
		date: '1 May 2020',
		amount: '$543.00',
		status: 'Pending',
		avatarColor: '#1890ff'
	},
	{
		id: '#5334',
		name: 'Stacey Ward',
		date: '28 April 2020',
		amount: '$876.00',
		status: 'Rejected',
		avatarColor: '#ffc542'
	},
	{
		id: '#5335',
		name: 'Troy Alexander',
		date: '28 April 2020',
		amount: '$241.00',
		status: 'Approved',
		avatarColor: '#ff6b72'
	},
];